import { Button } from "react-bootstrap";
import { exportCleanExcel } from "./exportCleanExcel";

const ExportExcel = ({ excelData }) => {
  const exportToExcel = () => {
    const userInput = window.prompt("Guardar tabla como:", "");
    if (userInput && excelData) {
      exportCleanExcel(excelData, userInput);
    }
  };

  return (
    <>
      <Button onClick={exportToExcel} className="btn-success btn-sm">
        Exportar Excel
      </Button>
    </>
  );
};

export default ExportExcel;
